import React from "react";
import "../assets/styles/mobileAppPages.css";

const PrivacyPolicy = () => {
  return (
    <div className="mobile-app-page">
      <div className="mobile-app-section">
        <div className="mobile-app-card">
          <div className="mobile-app-badge">Poolins</div>
          <h1 className="mobile-app-title">Politique de confidentialité</h1>
          <p className="mobile-app-subtitle" style={{ color: "var(--poolins-muted)" }}>
            Cette section est prévue pour décrire comment l’application Poolins (OSSAN ASUR) collecte
            et protège les données. Ajoutez ici votre contenu juridique complet dès qu’il est prêt.
          </p>
          <div className="mobile-app-notes">
            - Données d’authentification et informations de compte{"\n"}
            - Données nécessaires à la gestion des contrats et sinistres{"\n"}
            - Conservation sécurisée et accès restreint{"\n"}
            - Droits d’accès, de rectification et de suppression{"\n"}
            - Contact : support-apps@ossanasur.com
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
